__turbopack_context__.v({
  "error": "input-module__FwjuBW__error",
  "input": "input-module__FwjuBW__input",
  "label": "input-module__FwjuBW__label",
  "root": "input-module__FwjuBW__root",
  "section": "input-module__FwjuBW__section",
});
